import { useLeadInsuranceRequests } from '@/hooks/useLeadInsuranceRequests';
import type { Id } from '@convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import

interface IRequestsCountCellProps {
  // LOCAL_TYPE_JUSTIFIED: small private props type used only within this file
  leadId: Id<'leads'>;
}

export function RequestsCountCell({ leadId }: IRequestsCountCellProps) {
  const { requests } = useLeadInsuranceRequests(leadId);
  if (requests === undefined) return <span className="text-muted-foreground">…</span>;
  return <span>{requests.length}</span>;
}
